import { Alert, AlertDescription } from "@zapier/design-system";
import { useTranslations } from "@zapier/i18n";
import styles from "./DomainErrorBanner.module.css";

interface Props {
  domain: string;
  allowedDomains: string[];
  onDismiss: () => void;
}

export function DomainErrorBanner({
  domain,
  allowedDomains,
  onDismiss,
}: Props) {
  const t = useTranslations("connections-page");

  return (
    <div className={styles.banner}>
      <Alert
        status="error"
        title={t("domain-error.title")}
        onDismiss={onDismiss}
      >
        <AlertDescription>
          {t("domain-error.body", { domain })}
        </AlertDescription>
        {allowedDomains.length > 0 && (
          <AlertDescription>
            {t("domain-error.allowed-domains", {
              domains: allowedDomains.join(", "),
            })}
          </AlertDescription>
        )}
      </Alert>
    </div>
  );
}
